import { Component } from 'preact';
import PropTypes from 'prop-types';

export class FormButtons extends Component {
  render() {
    const { prevButtonDisabled, nextButtonDisabled, prevStep, nextStep } =
      this.props;

    return (
      <section className="test-drive-buttons">
        <button
          type="button"
          className="test-drive__button"
          onClick={prevStep}
          disabled={prevButtonDisabled}
        >
          Voltar
        </button>
        <button
          type="button"
          className="test-drive__button test-drive__button--next"
          disabled={nextButtonDisabled}
          onClick={nextStep}
        >
          Próximo
        </button>
      </section>
    );
  }
}

FormButtons.propTypes = {
  prevButtonDisabled: PropTypes.bool,
  nextButtonDisabled: PropTypes.bool,
  prevStep: PropTypes.func,
  nextStep: PropTypes.func,
};
